import { render, staticRenderFns } from "./DialogPermissoesPerfilAdministrativo.vue?vue&type=template&id=399eaca2&scoped=true&"
import script from "./DialogPermissoesPerfilAdministrativo.vue?vue&type=script&lang=js&"
export * from "./DialogPermissoesPerfilAdministrativo.vue?vue&type=script&lang=js&"
import style0 from "./DialogPermissoesPerfilAdministrativo.vue?vue&type=style&index=0&id=399eaca2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399eaca2",
  null
  
)

export default component.exports